{
  "addcategorybutton": "Add Category",
  "updatecategorybutton": "Update",
  "deletecategorybutton": "Delete",
  "categorytableheader": {
    "name": "Name"
  }
}
